import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome,
  faBars,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  // Load custom Arabic fonts
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-family: 'ITF Qomra Arabic';
        src: url('/fonts/itfQomraArabic-Black.ttf') format('truetype');
        font-weight: 900;
        font-style: normal;
      }
      @font-face {
        font-family: 'ITF Qomra Arabic';
        src: url('/fonts/itfQomraArabic-Bold.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
      }
      @font-face {
        font-family: 'ITF Qomra Arabic';
        src: url('/fonts/itfQomraArabic-Medium.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
      }
      @font-face {
        font-family: 'ITF Qomra Arabic';
        src: url('/fonts/itfQomraArabic-Regular.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'ITF Qomra Arabic';
        src: url('/fonts/itfQomraArabic-Light.ttf') format('truetype');
        font-weight: 300;
        font-style: normal;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Dark Theme Colors
  const theme = {
    darkEmerald: '#255853',
    emerald: '#357E77',
    goldenSand: '#D3BA80',
    lightGolden: '#E0CFA6',
    charcoal: '#32373B',
    darkGray: '#232729',
    pureWhite: '#FFFFFF',
    lightGray: '#F0F0F0',
    border: '#E0CFA6',
    hover: 'rgba(37, 88, 83, 0.1)',
    bg: '#0a0a0a',
    bgLight: '#111111',
    bgLighter: '#1a1a1a',
    text: '#ffffff',
    textMuted: '#a3a3a3'
  };

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  return (
    <>
      <Navbar 
        style={{ 
          background: theme.bgLight,
          borderBottom: `1px solid ${theme.goldenSand}`, 
          direction: 'rtl',
          fontFamily: "'ITF Qomra Arabic', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          minHeight: '64px',
          padding: '0.5rem 1rem'
        }}
        expand="lg"
        sticky="top"
      >
        <Container fluid className="px-2 px-lg-3">
          {/* Logo and Brand */}
          <LinkContainer to="/">
            <Navbar.Brand className="d-flex align-items-center p-0 m-0">
              <img 
                src="/amjad.png" 
                alt="أمجاد الأحرار" 
                style={{
                  width: '44px',
                  height: '44px',
                  objectFit: 'contain',
                  marginLeft: '8px'
                }}
              />
              <div className="d-flex flex-column">
                <span 
                  style={{
                    fontSize: '1.2rem',
                    fontWeight: '700',
                    color: theme.pureWhite,
                    lineHeight: '1.2',
                    fontFamily: "'ITF Qomra Arabic', 'Segoe UI', sans-serif"
                  }}
                >
                  أمجاد الأحرار
                </span>
                <small 
                  style={{
                    fontSize: '0.7rem',
                    color: theme.goldenSand,
                    fontWeight: '500',
                    marginTop: '2px',
                    fontFamily: "'ITF Qomra Arabic', 'Segoe UI', sans-serif",
                    maxWidth: '300px'
                  }}
                >
الموقع الرسمي لأمجاد الأحرار                </small>
              </div>
            </Navbar.Brand>
          </LinkContainer>

          {/* Mobile Menu Button */}
         

  
        </Container>
      </Navbar>

      {/* Offcanvas menu for mobile */}
      

      {/* Global styles to override Bootstrap */}
      <style jsx global>{`
        .navbar {
          background-color: #111111 !important;
        }
        .navbar-light .navbar-nav .nav-link {
          color: #a3a3a3 !important;
        }
        .navbar-light .navbar-nav .nav-link:hover {
          color: #ffffff !important;
        }
        .offcanvas {
          background-color: #111111 !important;
        }
        .offcanvas .nav-link {
          color: #a3a3a3 !important;
        }
        .offcanvas .nav-link:hover {
          color: #ffffff !important;
          background-color: rgba(37, 88, 83, 0.1) !important;
        }
        .navbar-toggler {
          border: none !important;
          padding: 0.25rem !important;
        }
        .navbar-toggler:focus {
          box-shadow: none !important;
        }
      `}</style>
    </>
  );
};

export default Header;